<template>
  <section class="bg-gray-100 px-4 py-24 md:py-48">
    <div class="mx-auto max-w-[1440px]">
      <div class="mb-24 text-center">
        <h2 class="text-4xl font-medium text-slate-800 md:text-5xl">{{ t('HomeHowItWorks.title') }}</h2>
      </div>

      <div class="grid grid-cols-1 justify-items-center gap-x-8 gap-y-25 sm:grid-cols-2 md:gap-x-6 lg:grid-cols-4">
        <div
          v-for="step in steps"
          :key="step.number"
          class="relative flex h-full max-w-[300px] min-w-[200px] flex-col items-center rounded-lg bg-yellow-500 p-8 pt-16 text-center text-white shadow-xl"
        >
          <div
            class="bg-rbgreen-450 absolute -top-10 flex h-[75px] w-[75px] items-center justify-center rounded-full text-4xl font-bold shadow-md"
          >
            {{ step.number }}
          </div>

          <div>
            <h5 class="mb-3 text-left text-2xl font-bold">{{ step.title }}</h5>
            <p class="text-left text-lg leading-6">
              {{ step.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n();

const steps = computed(() => [
  { number: 1, title: t('HomeHowItWorks.step1.title'), description: t('HomeHowItWorks.step1.description') },
  { number: 2, title: t('HomeHowItWorks.step2.title'), description: t('HomeHowItWorks.step2.description') },
  { number: 3, title: t('HomeHowItWorks.step3.title'), description: t('HomeHowItWorks.step3.description') },
  { number: 4, title: t('HomeHowItWorks.step4.title'), description: t('HomeHowItWorks.step4.description') },
]);
</script>
